
import { Component, OnInit, AfterViewInit, Inject, OnDestroy, HostListener } from '@angular/core';
import { EmitterService } from './services/emitter.service';
import { Utility } from './shared/utility/utility';
import { Router, NavigationStart, NavigationEnd, NavigationError, RoutesRecognized, ActivatedRoute } from '@angular/router';
import * as $ from 'jquery';
window['$'] = window['jQuery'] = $;
import { Location } from '@angular/common';
import { RealityCheckService } from './services/reality-check.service';
import { TranslateService } from '@ngx-translate/core';
import { AjaxService } from './services/ajax.service';
import { UserDetailsService } from './services/user-details.service';
import { AppDetailsService } from './services/app-details.services';
import { LogoutEmitServiceService } from './services/logout-emit-service.service';
import { WINDOW } from './services/window.service';
import { SessionLimitService } from './services/session-limit.service';
import 'pace-progressbar';
import {Meta , Title} from '@angular/platform-browser';

import {
  maplocation,
  browsertoSupportedLanguageMappingList
} from './shared/utility/config';
import * as _ from 'underscore';
import { CustomValidators } from './shared/utility/custom-validator';
import { CountryDataService } from './services/country.service';
import { environment } from "../environments/environment";
import { LiveGamesService } from './services/live-games.service';
import { takeUntil, filter } from "rxjs/operators";
import { Subject, fromEvent } from "rxjs";
import { PnpUserService } from './pnp-user.service';
import { GameWindowService } from './services/gameWindow.services';
import { PromotionsService } from './services/promotions.service';
import { IFrameService } from './cashier/services/i-frame.service';
import SwiperCore , {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Virtual,
  Zoom,
  Autoplay,
  Thumbs,
  Controller,
} from 'swiper';
SwiperCore.use([
  Navigation
]);
import { StaticPageService } from './services/static-page.service';
import { EnvironmentService } from './shared/services/environment.services';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  prevUrl: any;
  isGameLaunch: boolean;
  isStatic: boolean = false;
  accountStatusMsgs = false;
  serverErrorMsg: any;
  url;
  footerDisable;
  sessionLimit;
  userDetail;
  currencySymbol;
  name;
  balance;
  gamingSession = false;
  countryCode;
  isCountryBlocked;
  path;
  currentURL_slug: any;
  currentURL = '';
  langCode: any = "en";
  customServerErrorMsg;
  isUserLoggedIn: boolean;
  countryAccess;
  countryList;
  CustomValidators: CustomValidators = new CustomValidators(this.translate);
  isLoggedIn: boolean;
  maintenanceStatus = false;
  swedenCountry = 0;
  queryparameter = null;
  loading = false;
  landingPage = false;
  isLogin: boolean;
  isRegister: boolean;
  ishomePage: boolean;
  isBonuses: boolean;
  isCashierpage: boolean;
  windowType: string;
  isAccountLocked:boolean=false;
  gameplayWindowMinimized:boolean=false;
  gameplayWindowClosed:boolean=false;
  showGameplayWindow:boolean=false;
  destroy$: Subject<boolean> = new Subject<boolean>();
  translates
  showBanner= false;
  userDetailsForBanner:any;
  oldUrlCheck;
  isForgotPwd: boolean;
  newWindowPaymentMethods = ['/PLIXPAY','/ARI10'];
  siteCode= environment.website_code
  documentClicks$ = fromEvent(document, 'click');
  mappedLanguageCodes;
  savedEvent;
  tugichatEnabled = environment.tugiChatConfig.tugiChatEnabled;
  
  @HostListener("window:resize") onResize() {
    this.deviceType();
    if (location.href.includes('gameplay')) {
      setTimeout(() => {
        this.wrapperHeight();
      })
    }
  }

  constructor(
    private translate: TranslateService,
    private emitterService: EmitterService,
    private router: Router,
    private location: Location,
    private realityCheckService: RealityCheckService,
    private ajaxService: AjaxService,
    public userService: UserDetailsService,
    private logoutEmitService: LogoutEmitServiceService,
    private utils: Utility,
    @Inject(WINDOW) private window: Window,
    private countryDataService: CountryDataService,
    private appDetailsService: AppDetailsService,
    private liveGames: LiveGamesService,
    private sessionLimitService: SessionLimitService,
    private activatedRoute: ActivatedRoute,
    private metaService: Meta,
    private titleService: Title,
    private pnpUserService:PnpUserService,
    private gameWindowService:GameWindowService,
    private promotionsService:PromotionsService,
    private  iFrameService:IFrameService,
    private staticPageService:StaticPageService,
    private environmentServie:EnvironmentService
  ) {
    this.mappedLanguageCodes = this.environmentServie.getActiveLanguageConfig();

    this.documentClicks$.subscribe((event: MouseEvent) => {
      let target:any = event.target;
      if(target?.id == 'termsAndConditions' && target?.dataset?.target || target?.id == 'marketingAndAgreeement' && target?.dataset?.target){
        this.router.navigate([target.dataset.target]);
        this.emitterService.broadcastModalState({ name: "pnpDepositModal", state: "close" });
      }
    });
    this.langCode = localStorage.getItem('langCode') ? localStorage.getItem('langCode') : "";
    if(this.newWindowPaymentMethods?.some((method)=> window.location.href.includes(method))){
      localStorage.setItem('iframeRedirection',"true");
    }

    this.gameIframeRedirection();
    this.translates = this.translate;
    this.isUserLoggedIn = this.utils.isUserLoggedIn();
    this.liveGames.connect(environment.liveGameUrl, environment.liveGameCasioID);
    this.emitterService.maintenanceemitter$.pipe(takeUntil(this.destroy$)).subscribe(status => {
      if (status) {
        this.maintenanceStatus = true;
      } else {
        this.maintenanceStatus = false;
      }
    });

    this.emitterService.updateLoginStatus$.pipe(takeUntil(this.destroy$)).subscribe(loginStatus => {
      this.isLoggedIn = loginStatus;
      // Closing The Minimised Game Window on logout
      this.emitterService.broadCastIsGameLanuched(false);
      this.utils.setActiveGameInfo(null);
      this.emitterService.broadCastGameWindowMinimized(false);
      this.utils.setIsGametoBeLaunched(true);
    });

    this.emitterService.landingpageSource$.pipe(takeUntil(this.destroy$)).subscribe(status => {
      this.landingPage = status;
    });
    this.emitterService.staticPageApiResponse$.pipe(takeUntil(this.destroy$)).subscribe((staticPageResponse) => {
      const allLanguages = this.translates.getLangs();
      this.updatePathInfo(staticPageResponse,allLanguages,'')
    });

    this.emitterService.clearePromotionData$.pipe(takeUntil(this.destroy$)).subscribe(status => {
      this.promotionsService.promotionsDataResponse = null;
    });
   

    this.emitterService.isGameWindowMinimized$.pipe(takeUntil(this.destroy$)).subscribe((status)=>{
      this.gameplayWindowMinimized=status;
    });

    this.emitterService.isGameWindowClosed$.pipe(takeUntil(this.destroy$)).subscribe((status)=>{
      this.gameplayWindowClosed=status;
    });

    this.emitterService.isGamewindowLanuched$.pipe(takeUntil(this.destroy$)).subscribe((status)=>{
      this.showGameplayWindow=status;
    });

    this.router.events.pipe(takeUntil(this.destroy$)).subscribe(event => {
      if(this.router.url == '/'+this.langCode+'/casino'){
        window.location.pathname = '/'+this.langCode;
        return true;
      }

      if (event instanceof NavigationStart) {

        this.loading = true;
        let gameInfo=this.utils.getActiveGameInfo();

        // Minimize the Game play window when click on other links code 
        const isIgnoredUrl = ['page', 'login', 'register'].some(term => event.url.includes(term));
        if(this.router.url && this.router.url.includes('gameplay') && !isIgnoredUrl && this.windowType === 'desktop' && !this.gameplayWindowClosed){
            this.utils.setIsGameWindowMinimized(true);
            this.gameplayWindowMinimized = true;
        }
         this.gameplayWindowClosed = false;
        //ends
        
        if (gameInfo != null) {
          if (event.url.includes(gameInfo.gameId) || event.url.includes(gameInfo.gameLaunchUrlPath)) {
            this.gameplayWindowMinimized = false
          }
        }else if (event.id >= 3 && event.url.includes('gameplay')) {
          // let gameDetails = this.emitterService.getLatestgame()
          // this.router.navigate([this.langCode]);
          // let gameDetails = this.emitterService.getLatestgame()
          let openedGamesList = this.emitterService.getGamesHistoryList();
          // this.router.navigate([this.langCode]);
          let activeUrlGameId = event.url.split('gameplay/')[1]
          let gameDetails = openedGamesList.filter((game)=>game.gameId === activeUrlGameId || game.gameLaunchUrlPath === activeUrlGameId)
          if(this.utils.isUserLoggedIn()){
            this.gameWindowService.loadGame('realgames', gameDetails[0].gameId, gameDetails[0].gameLaunchUrlPath)
          }else{
            this.gameWindowService.loadGame('', gameDetails[0].gameId, gameDetails[0].gameLaunchUrlPath)
          }
        }

        if(event.url.includes('gameplay')){
          setTimeout(()=>{
            this.wrapperHeight();
          })
          window.addEventListener('popstate', (e) => {
            this.savedEvent = e;
            if(this.savedEvent){              
              this.gameplayWindowClosed = true;
            }
          }) 
        }
        
      
        if(event.url && !event.url.includes('gameplay') && !this.gameplayWindowMinimized){
          
          if(gameInfo && Object.keys(gameInfo).length>0){
            this.emitterService.broadCastIsGameLanuched(false);
            this.utils.setActiveGameInfo(null);
            this.utils.setIsGametoBeLaunched(false);
          }
        }

        if (event.url && event.url.includes('gameplay')) {
          this.isGameLaunch = true;
          this.utils.setIsGameWindowMinimized(false);
          this.gameplayWindowMinimized = false;
        } 

      } else if (event instanceof NavigationEnd) {
        this.loading = false;

        /* PhoneNumberFlag dropdown list is not closing in
           mobile when user going back to previous page */
        if ($(".intl-tel-input.iti-container").length > 0) {
          $("body").trigger("click");
        }

        this.setHrefsToLinkTagsInHeadSection();
      } else if (event instanceof NavigationError) {
        this.loading = false;
      }

      if (event instanceof RoutesRecognized) {

        let routeData = event.state.root.firstChild.data;

        if (!Object.is(routeData, {}) && routeData.staticPage) {
          this.isStatic = true;
        } else {
          this.isStatic = false;
        }
        if (!Object.is(routeData, {}) && routeData.homePage) {
          this.ishomePage = true;
          this.utils.setIsHomePage(true);
        } else {
          this.ishomePage = false;
          this.utils.setIsHomePage(false);
        }
      }

    });
    

    translate.addLangs(this.mappedLanguageCodes);
    //const browserLang = translate.getBrowserLang();
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).pipe(takeUntil(this.destroy$)).subscribe((e) => {
      this.isGameLaunch = false;
      this.isLogin = false;
      this.isRegister = false;
      this.isForgotPwd= false;

      if (window.location.href.includes("gameplay")) {
        this.isGameLaunch = true;
      } 
      
      if (window.location.href.includes("login")) {
        this.isLogin = true;
      } 

      if (window.location.href.includes("register")) {
        this.isRegister = true;
      }
      if (window.location.href.includes("forgotpassword")) {
        this.isForgotPwd = true;
      }

      this.getMetaDataForByRoute(this.activatedRoute);

      //Game page footer issue on scroll in IOS devices
      if(this.isGameLaunch){
        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
          if (isSafari) {
            setTimeout(function(){
              window.scrollTo(0, 1);
            },500);
          }
      }
    });

    this.logoutEmitService.CountryBlockEvent$.pipe(takeUntil(this.destroy$)).subscribe(country => {
      this.userService.removeUserData();
      this.isCountryBlocked = true;
      this.countryCode = country;
    });
    
    this.emitterService.serverError$.pipe(takeUntil(this.destroy$)).subscribe(status => {
      if (status['statusErrors'].indexOf('accountStatus') !== -1) {
        this.accountStatusMsgs = true;
      } else {
        this.accountStatusMsgs = false;
      }

      if (status && status.statusErrors.length !== 0) {
        this.serverErrorMsg = status.statusErrors;
        this.url = status.url;
        $("#serverErrorPopUp").show();
      }
    });

    this.emitterService.customServerError$.pipe(takeUntil(this.destroy$)).subscribe(status => {
      if (status.length !== 0) {
        this.customServerErrorMsg = status;
        $("#customServerErrorPopUp").show();
      }
    });

    this.realityCheckService.sessionLimit$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      if (sessionStorage.getItem("session")) {
        this.gamingSession = true;
        this.sessionLimit = JSON.parse(sessionStorage.getItem("session")).sessionLimit;
        this.userDetail = this.userService.getUserProfileDetails();
        this.currencySymbol = this.userService.getUserCurrencySymbol();
        if (this.userDetail) {
          this.name = this.userDetail.firstName + " " + this.userDetail.lastName;
        }
      }
    });
    
    this.emitterService.isUserAccountLocked$.pipe(takeUntil(this.destroy$)).subscribe(status=> {​​​​​​​​
      this.isAccountLocked = status;
      if(status){​​​​​​​​
        this.router.navigate([this.langCode]);
      }​​​​​​​​
    }​​​​​​​​);

    this.emitterService.updateMetaInfo$.pipe(takeUntil(this.destroy$)).subscribe(metaInfo=>{
      this.setMetaDataForSite(metaInfo);
    });

    //Adding class for Promotion detailed page 
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        if(event["url"].includes(this.langCode) &&  event["url"].split("/").length <= 2){
          document.body.classList.add('homepage');
        }else{
          document.body.classList.remove("homepage");
        }
        if (event["url"]?.includes('promotions/')) {
          document.body.classList.add("scrollPosProm","promo-page");
        } else if (!event["url"]?.includes('promotions/')) {
          document.body.classList.remove("scrollPosProm", "promo-page");
        }
        if (event["url"]?.includes('page/')){
          document.body.classList.add("static-page");
          document.body.classList.remove("gm-play-page");
        } else if(event["url"]?.includes('gameplay')){
          document.body.classList.add("gm-play-page");

        }
        else{
          document.body.classList.remove("static-page","gm-play-page");
        }
      }
    })
    
  }


  deviceType() {
    this.windowType = document.body.clientWidth <= 992 ? 'tab' : 'desktop';
  }
  

  wrapperHeight(){
    /** ESI- 6781 Calculate Dynamic hei`ght for the main_wrapper in game play page to make footer at bottom always */
    let main_wrapper = document.querySelector('.home_page--container_right');
    let footer = document.querySelector('.footer');
    let main_wraper_min = document.querySelector('.main_wrapper');
    let iframeWrapper = document.querySelector('.gamesdefaultbg');
    
    let mainContainerHeight = main_wrapper?.clientHeight;          
    let footerHeight = footer?.clientHeight;
    let mainWrapperHeight = main_wraper_min?.clientHeight; // main_wrapper div height
    let gameIframeHeight = iframeWrapper?.clientHeight;

    let main_wrapper_minHeight = mainContainerHeight - footerHeight - gameIframeHeight;
    let containerFinalHeight = mainWrapperHeight - main_wrapper_minHeight ;   

    if (main_wraper_min instanceof HTMLElement) {
      main_wraper_min.style.minHeight = `${containerFinalHeight - 2}px`;
    }

  }

  switchLanguage(language: string) {
    this.translate.use(this.utils.getActualMappedLanguage());
  }
  ngOnInit() {
    // this.router.events.subscribe(event => {
    //   if (event instanceof NavigationStart) {
    //     // This is called on every route change, including redirects
    //     this.utils.showFooterAfterScroll();
    //   }
    // });
    /**In below code we are adding logged_out/logged_in class to the body based on users log status.
     * by default we are sdding logged_out status and based on condition we are removing and adding required class. 
    */
    document.body.classList.add("logged_out")
    this.emitterService.updateLoginStatus$.pipe(takeUntil(this.destroy$)).subscribe(loginStatus => {
      if (loginStatus) {
        document.body.classList.remove("logged_out")
        document.body.classList.add("logged_in")
      } else {
        document.body.classList.remove("logged_in")
        document.body.classList.add("logged_out")
      }
    });
    const ww = document.body.clientWidth;
    let isUserLoggedIn = localStorage.getItem('user');
    if(window.location.href.includes('redirect=deposit-transactionStatus') && ww <= 992 && !isUserLoggedIn){
      this.utils.isMobileDepositModal = true;
      setTimeout(()=>{
        this.emitterService.broadcastModalState({name:"pnpDepositModal",state:"open", cashierType: "deposit" });
      },100);
      setTimeout(()=>{
        this.pnpUserService.getPNPUserFromTransaction();
      },1000);
    }
   
    if(this.router.url == '/'+this.langCode+'/casino'){
      window.location.pathname = '/'+this.langCode;
      return true;
    }
    this.translates = this.translate;
    this.utils.loadPaymentIqEncryptor();

    /*
      Moved from outer navigation to ngOnit. As without blocked country site does not load.
      Second why call the blocked country call on each nagivation end!
      Handle cases: Phone number code on form on banner, phone number on step1 of registration
    */
    this.isCountryBlocked = false;
    let lang = null;
    /*
      Capture the language from URL "substring(1, 3)" where substring(3, 4) == "" or '/' or browser language
      Logged out State:
      a.               URL (language code present in URL)
                (YES)/     \ (NO)
                    /       \
        website(URL lang)   Browser Language
                        (Yes)/         \(No)(case: browser does not support language selection/
                            /           \    browser language is different ex.Spanish and buumi.com does not have Spanish )
            website(Browser lang)      IPCountry based language

      Logged in State:
       ** Always override everything and show user profile language
    */
    if (window.location.pathname.substring(3, 4) === "" || window.location.pathname.substring(3, 4) === '/') {
      // lang = window.location.pathname.substring(1, 3) ?
      // window.location.pathname.substring(1, 3) : localStorage.getItem('langCode') ? localStorage.getItem('langCode') : null;
      let urlLang = window.location.pathname.substring(1, 3);

      if (_.contains(this.mappedLanguageCodes, urlLang)) {
        lang = urlLang;
      }
      else if (localStorage.getItem('langCode')) {
        lang = localStorage.getItem('langCode');
      }
      // lang = window.location.pathname.substring(1, 3) ?
      // window.location.pathname.substring(1, 3) : localStorage.getItem('langCode')?localStorage.getItem('langCode'):null;
    } else {
      // lang = window.location.pathname.split('/')[0] ?
      // window.location.pathname.split('/')[0] : localStorage.getItem('langCode') ? localStorage.getItem('langCode') : null;
      let url = window.location.pathname.split('/')[0];
      if (_.contains(this.mappedLanguageCodes, url)) {
        lang = url;
      }
      else if (localStorage.getItem('langCode')) {
        lang = localStorage.getItem('langCode');
      }
      // lang = window.location.pathname.split('/')[0] ?
      // window.location.pathname.split('/')[0] : localStorage.getItem('langCode')?localStorage.getItem('langCode'):null;
    }
    lang = lang === 'sv' ? 'en' : lang; // Force change sv to en
    /* Capturing the query parameter and storing in a variable to be clubbed during nagivation */
    if (window.location.search.length > 0) {
       let queryParamsJson = {}; 
       let searchSigment:any = window.location.search;
       let urlQuery = searchSigment.replaceAll('?',"").split("&");
        urlQuery.filter((param:any) =>{
          let paramArr = param.split("=");
          queryParamsJson[paramArr[0]] = paramArr[1];
        })
      this.queryparameter = queryParamsJson;
    }
    if (_.contains(this.mappedLanguageCodes, lang)) {
      /* Capturing the url apart from the language e.g: '/en'" */
      if (window.location.pathname.substring(3, 4) !== "" && window.location.pathname.substring(3, 4) !== '/') {
        this.currentURL_slug = window.location.pathname;
      } else {
        this.currentURL_slug = (window.location.pathname).indexOf('callback') >= 0 ?
          window.location.pathname : window.location.pathname.substring(3);
      }
    } else {
      this.currentURL_slug = window.location.pathname;
    }
    let storedLang = localStorage.getItem('langCode');
      if(storedLang && lang && storedLang != lang){
        localStorage.setItem('langCode', lang);
        location.href = '/'+lang
        return
      }
    Promise.resolve(this.appDetailsService.getBlockedCountries()).then(res => {
      /* This case to handle if user directly goes to register*/
      if (res && res["countryCode"]) {
        this.countryDataService.ipCountry = res["countryCode"];
      } else {
        this.countryDataService.ipCountry = "MA";
      }
      if (res && res["isIpBlocked"] && JSON.parse(res["isIpBlocked"]) === true) {
        this.isCountryBlocked = true;
      } else if (res && res["isIpBlocked"] && JSON.parse(res["isIpBlocked"]) === false) {
        this.isCountryBlocked = false;
      } else {
        this.isCountryBlocked = false;
        this.countryCode = "-NA-";
      }
      
      /* Function to get the country from URL or from country if not present in URL*/
      this.selectLanguage(lang);
    },
      SystemError => {
      });

    this.displayHeaderFooter();
    if (sessionStorage.getItem("session")) {
      this.gamingSession = true;
      this.sessionLimit = JSON.parse(sessionStorage.getItem("session")).sessionLimit;
      this.userDetail = this.userService.getUserProfileDetails();
      this.currencySymbol = this.userService.getUserCurrencySymbol();
      if (this.userDetail) {
        this.name = this.userDetail.firstName + " " + this.userDetail.lastName;
        this.balance = this.currencySymbol + " " + this.userDetail.balanceDetails.cash;
      }
    }
    $.extend($.expr[':'], {
      focusable: function (el, index, selector) {
        return $(el).is('a, button, :input, [tabindex]');
      }
    });

    $(document).on('keypress', 'input,select', function (e) {
      if (e.which === 13) {
        e.preventDefault();
        // Get all focusable elements on the page
        let $canfocus = $(':focusable');
        let index = $canfocus.index(document.activeElement) + 1;
        if (index >= $canfocus.length) { index = 0; }
        $canfocus.eq(index).focus();
      }
    });
    //Functionality to Handle page change Events for Google Analytics
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).pipe(takeUntil(this.destroy$)).subscribe(currentRoute => {
        this.utils.gtmEvent("pageNavigation", {
          route: (currentRoute as any).url
        });
        let iframeRedirection = localStorage.getItem('iframeRedirection') == 'true'? true:false;
       
        if(iframeRedirection && this.newWindowPaymentMethods.every((method)=> !window.location.href.includes(method))){
          localStorage.setItem('transactionStatusIsLoading', 'true');
          this.emitterService.broadCastCashierModalState(true);
          setTimeout(()=>{
            this.emitterService.broadCastCashierLoader(true);
          },10)
          setTimeout(()=>{
            localStorage.removeItem('iframeRedirection');
            this.emitterService.broadCastCashierModalState(true);
            this.utils.openModal("custom_cashier_modal");
            let txnId = localStorage.getItem('iframePaymentMethodTxnID');
            if(txnId){
              this.iFrameService.transactionHandlerWithTxnId(txnId);
            }
          },100)
          }
      });
    this.deviceType();
    this.setHrefsToLinkTagsInHeadSection();
   

  }

  /* Navigating to home page on clicking on Home
  Icon inside game window Iframe for Mobile devices */
  gameIframeRedirection() {
    const ww = document.body.clientWidth;
    //if (ww <= 1024) {
    let windowParentOrigin = window.parent.location.origin;
    let doc = window.parent.document;
    let iframeId = doc.getElementById("netentgame") ? "netentgame" : "gamePlayIframe";
    const element: HTMLIFrameElement = doc.getElementById(iframeId) as HTMLIFrameElement;
    if (element) {
      const iframe = element.contentDocument || element.contentWindow.document;
      const iframeOrigin = iframe.location.origin;
      if (iframeOrigin === windowParentOrigin) {
        let clsoeEle = window.parent.document.getElementsByClassName("gamewindow_close-btn");
        $(clsoeEle).trigger("click");
      }
    }
    //}
  }



  setHrefsToLinkTagsInHeadSection() {
    if (!this.oldUrlCheck || this.oldUrlCheck !== window.location.pathname) {
      this.oldUrlCheck = window.location.pathname;
      $('link[hreflang]').remove();
  
      const allLanguages = this.translates.getLangs();
      const urlSlug = window.location.pathname.substring(3);
      const linkTagsCollection = '';

       if (urlSlug.includes('/casino/') && !urlSlug.includes('allgames')) {
        this.updateLobbyAndGroupUrlsDynamic(allLanguages, linkTagsCollection);
      } else if (urlSlug.includes('/promotions/') && urlSlug !== '/promotions' && urlSlug !== '/promotions/') {
        this.updatePromotionDynamicUrls(allLanguages, linkTagsCollection, urlSlug.split('/')[2]);
      } else {
        this.updateDefaultDynamicLinks(allLanguages, linkTagsCollection);
      }
  
      $('head').append(linkTagsCollection);
    }
  }
  

  updateLobbyAndGroupUrlsDynamic(allLanguages, linkTagsCollection) {
    const self = this;
    const urlSlug = window.location.pathname.substring(3);
  
    this.gameWindowService.getLobbies().subscribe((lobbies) => {
      if (lobbies && lobbies.length) {
        const urlInfo = urlSlug.split('/casino/');
        let lobbyName = '';
        let groupName = '';
  
        if (!urlInfo[0] && urlInfo[1] && !urlInfo[1].includes('/')) {
          lobbyName = urlInfo[1];
          this.updateLobbyLinks(allLanguages, lobbyName, lobbies, linkTagsCollection);
        } else {
          const lobbyGroupInfo = urlInfo[1].split('/');
          lobbyName = lobbyGroupInfo[0];
          groupName = lobbyGroupInfo[1];
          this.updateLobbyAndGroupLinks(allLanguages, lobbyName, groupName, lobbies, linkTagsCollection);
        }
      } else {
        this.updateDefaultDynamicLinks(allLanguages, linkTagsCollection);
      }
    });
  }
  
  private updateLobbyLinks(allLanguages, lobbyName, lobbies, linkTagsCollection) {
    const currentLobby = this.getCurrentLobby(lobbyName, lobbies);
  
    if (currentLobby) {
      allLanguages.forEach((lang) => {
        const updatedUrl = this.updateLobbyUrl(lobbyName, currentLobby, lang);
        linkTagsCollection = this.updateDynamicSEOLinks(updatedUrl, lang, linkTagsCollection);
      });
    } else {
      linkTagsCollection = this.updateDefaultDynamicLinks(allLanguages, linkTagsCollection);
    }
    this.updateHeadWithLinks(linkTagsCollection);
  }
  
  private updateLobbyAndGroupLinks(allLanguages, lobbyName, groupName, lobbies, linkTagsCollection) {
    const currentLobby = this.getCurrentLobby(lobbyName, lobbies);
  
    if (currentLobby) {
      allLanguages.forEach((lang) => {
        const updatedUrl = this.updateLobbyAndGroupUrl(lobbyName, groupName, currentLobby, lang);
        linkTagsCollection = this.updateDynamicSEOLinks(updatedUrl, lang, linkTagsCollection);
      });
    } else {
      linkTagsCollection = this.updateDefaultDynamicLinks(allLanguages, linkTagsCollection);
    }
    this.updateHeadWithLinks(linkTagsCollection);
  }
  
  private updateLobbyUrl(lobbyName, currentLobby, lang) {
    const multilingualUrlLobby = currentLobby[0].multilingualUrlLobby[this.utils.getActualMappedLanguage(lang)];
    return multilingualUrlLobby ? `/casino/${multilingualUrlLobby}` : window.location.pathname.substring(3);
  }
  
  private updateLobbyAndGroupUrl(lobbyName, groupName, currentLobby, lang) {
    const lobbyGroup = currentLobby[0].gameGroupList.find(lGroup => lGroup.multilingualUrlGameGroup[this.langCode] === groupName);
  
    if (lobbyGroup) {
      const multilingualUrlLobby = currentLobby[0].multilingualUrlLobby[this.utils.getActualMappedLanguage(lang)];
      const multilingualUrlGameGroup = lobbyGroup.multilingualUrlGameGroup[this.utils.getActualMappedLanguage(lang)];
      return multilingualUrlLobby && multilingualUrlGameGroup ? `/casino/${lobbyName}/${multilingualUrlGameGroup}` : window.location.pathname.substring(3);
    } else {
      return window.location.pathname.substring(3);
    }
  }
  
  private updateHeadWithLinks(linkTagsCollection) {
    $('link[hreflang]').remove();
    $('head').append(linkTagsCollection);
  }
  
 
  updateStaticPagesDynamicPath(allLanguages,linkTagsCollection,footerUrl){
   if(!this.staticPageService.staticPageInfo[this.langCode+footerUrl]){
    Promise.resolve(this.staticPageService.getStaticPageData(this.langCode,footerUrl)).then((data)=>{
      this.updatePathInfo(data,allLanguages,linkTagsCollection);
      if(data['status'] != '"FAILURE"')
      this.staticPageService.staticPageInfo[this.langCode+footerUrl]=data;
    })
   }else{
    this.updatePathInfo(this.staticPageService.staticPageInfo[this.langCode+footerUrl],allLanguages,linkTagsCollection)
   }
  }
  updatePathInfo(data,allLanguages,linkTagsCollection){
    let self = this;
    if(data){
      allLanguages.forEach((lang) => {
        let urlSlug = window.location.pathname.substring(3);
         urlSlug = data.multilingualUrl && data.multilingualUrl[self.utils.getActualMappedLanguage(lang)] ? "/page/"+data.multilingualUrl[self.utils.getActualMappedLanguage(lang)] : urlSlug; 
         linkTagsCollection = this.updateDynamicSEOLinks(urlSlug,lang,linkTagsCollection)
      });
    }else{
      linkTagsCollection =  self.updateDefaultDynamicLinks(allLanguages,linkTagsCollection);
    }
    $('link[hreflang]').remove();
    $('head').append(linkTagsCollection);
  }
  updateDynamicSEOLinks(urlSlug,lang,linkTagsCollection){
    let hrefLangVal = environment.hreflangAttributeCodes[lang];
    let hrefVal = urlSlug.length ? window.location.origin+'/'+lang+''+urlSlug : window.location.origin+'/'+lang;
    linkTagsCollection += "<link rel='alternate' href='"+hrefVal+"' hreflang='"+hrefLangVal+"' />";
    if(lang === 'en') {
        linkTagsCollection += "<link rel='alternate' href='"+hrefVal+"' hreflang='x-default' />";
    }
    return linkTagsCollection;
  }

  updateDefaultDynamicLinks(allLanguages,linkTagsCollection){
    allLanguages.forEach((lang) => {
      let urlSlug = window.location.pathname.substring(3);
      linkTagsCollection = this.updateDynamicSEOLinks(urlSlug,lang,linkTagsCollection)
    });
    return linkTagsCollection;
  }

  updatePromotionDynamicUrls(allLanguages,linkTagsCollection,promotionName){
    let self = this;
    Promise.resolve(this.promotionsService.getPromotionsData()).then(promotionsData => {
      if(promotionsData){
        let currentPromotion = promotionsData.filter(promotion => promotion && promotion.multilingualUrl && promotion.multilingualUrl[self.langCode] == promotionName);
        if(currentPromotion){
          allLanguages.forEach((lang) => {
              let urlSlug = window.location.pathname.substring(3);
              urlSlug = currentPromotion[0].multilingualUrl[self.utils.getActualMappedLanguage(lang)] && currentPromotion[0].multilingualUrl && currentPromotion[0].multilingualUrl[self.utils.getActualMappedLanguage(lang)] ? "/promotions/"+currentPromotion[0].multilingualUrl[self.utils.getActualMappedLanguage(lang)] :  urlSlug 
              linkTagsCollection = this.updateDynamicSEOLinks(urlSlug,lang,linkTagsCollection)
           });
           $('link[hreflang]').remove();
           $('head').append(linkTagsCollection);
           return;
        }else{
          linkTagsCollection =  self.updateDefaultDynamicLinks(allLanguages,linkTagsCollection);
        }
      }else{
        linkTagsCollection =  self.updateDefaultDynamicLinks(allLanguages,linkTagsCollection);
      }
    });
  }
getCurrentLobby(lobbyName,lobbies){
  let currentLobby =undefined;
  if(lobbyName == 'home'){
   currentLobby= lobbies.filter(lobby => lobby && lobby.multilingualUrlLobby && lobby.name.toLowerCase().includes('home'));
  }else{
   currentLobby= lobbies.filter(lobby => lobby && lobby.multilingualUrlLobby && lobby.multilingualUrlLobby[this.utils.getActualMappedLanguage(this.langCode)] == lobbyName);
  }
  return currentLobby;
}
  onActivate(){
    this.emitterService.broadcastRouteChange(false);
  }
  ngAfterViewInit() {
    $("body").on('click', function () {
      $("#serverErrorPopUp").hide();
      $("#customServerErrorPopUp").hide();
    });
    $(document).on('click', '#serverErrorPopUp', function (event) {
      event.stopPropagation();
    });
  }
  /*Gets the language from URL or Countrycode if not from URL*/
  selectLanguage(lang) {
    /*If language is in the url*/
    if (_.contains(this.mappedLanguageCodes, lang)) {
      /* Capturing the url apart from the language e.g: '/en'" */
      this.routepath(lang, this.currentURL_slug, this.queryparameter);
    } else {
      /*
      ** Checking the url path and the queryparameter before the promise call and
      ** keeping them ready to navigate, once the country of the user is realised.
      ** Please Note: Capturing the whole URL as language is not there.
      */
      /** commenting below line as this.currentURL_slug is setting to "/"
       * as window.location.pathname is "/"
       */
      // this.currentURL_slug = window.location.pathname;
      let country = this.countryDataService.ipCountry;
      let browserLang = _.contains(this.mappedLanguageCodes, navigator.language) ?
        navigator.language : browsertoSupportedLanguageMappingList[navigator.language];
      this.langCode = 'en';
      /* If language is not in the url, then get country and then corresponding language from json */
      if (environment.countryLanguage[country]) {
        if(_.isArray(environment.countryLanguage[country])){
          this.langCode = _.contains(environment.countryLanguage[country], navigator.language) ? browsertoSupportedLanguageMappingList[navigator.language] : environment.countryLanguage[country][0];
        }else{
          this.langCode = environment.countryLanguage[country];
        }
      }
      else if (browserLang) {
        this.langCode = browserLang;
      }
      this.routepath(this.langCode, this.currentURL_slug, this.queryparameter);
    }
    this.getCountries();
  }
  routepath(lang, currentURL_slug, queryparameter) {
    this.langCode = lang;
    localStorage.setItem('langCode', this.langCode);
    this.translate.use(this.utils.getActualMappedLanguage());
    $('html').attr('lang', this.langCode).attr('xml:lang', this.langCode).attr('xmlns', "http://www.w3.org/1999/xhtml");
    if (this.queryparameter) {
      this.router.navigate([this.langCode + currentURL_slug], { queryParams: this.queryparameter });
    } else {
      if (this.window.location.pathname.includes('setlimits') && !this.utils.isUserLoggedIn()) {
        this.router.navigate([this.langCode + '/login'], { queryParams: { toSetLimit: 'setlimits' } });
      } else if (this.window.location.pathname.includes('accountstatus') && !this.utils.isUserLoggedIn()) {
        this.router.navigate([this.langCode + '/login'], { queryParams: { toAccountstatus: 'accountstatus' } });
      } else if (this.window.location.pathname.includes('sms') && !this.utils.isUserLoggedIn()) {
        this.router.navigate([this.langCode + '/login'], { queryParams: { toAccountpreferences: 'accountpreferences' } });
      } else {
        this.router.navigate([this.langCode + currentURL_slug], { queryParamsHandling: 'preserve' });
      }
    }
    setTimeout(() => {
      this.emitterService.broadcastLangCode(this.langCode);
      this.emitterService.broadcastGetLangBasedResponse(true);
    }, 1);
  }
  getCountries() {
    Promise.resolve(this.countryDataService.getCountriesDetails())
      .then((countries): any => {
        this.countryList = countries;
        this.countryDataService.setData(this.countryList);        
        const bodyClass = `country_${countries["countryCode"]}`;
        document.body.classList.add(bodyClass);
      })
      .catch(error => {
        console.error('Error fetching countries:', error);
      });
  }
  
  displayHeaderFooter() {
    this.router.events.pipe(takeUntil(this.destroy$)).subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        this.path = this.location.path();
        let count = maplocation.length;
        for (let i = 0; i < maplocation.length; i++) {
          if (this.location.path().includes(maplocation[i])) {
            this.footerDisable = false;
            i = count++;
          } else {
            this.footerDisable = true;
          }
        }
        window.scrollTo(0, 0);
        this.setHrefsToLinkTagsInHeadSection();
        if(!window.location.href.includes('register')){
          this.emitterService.broadcastRouteChange(false);
        }
      }
    });
  }
  closeServsErr() {
    if (this.url.includes('deposit')) {
      this.router.navigate([this.url], { skipLocationChange: true });
    } else if (this.url === '/') {
      this.router.navigate([this.url], { skipLocationChange: true });
      setTimeout(() => {
        this.emitterService.broadCastUserCountry(this.countryDataService.IPCountry);
      }, 1000);
    } else if (this.url === ("/"+this.langCode)) {
      this.router.navigate([this.url]);
    } else {
      if(this.url != ""){
        if(this.url.includes('forgotpassword')){
          this.router.navigate([this.langCode+'/forgotpassword'],{ queryParams: { "prevUrl": 'login' }});
        }else{
          this.router.navigate([location.pathname]);
        }       
      }
      this.serverErrorMsg = [];
    }
  }
  closeCustomServsErr() {
    this.customServerErrorMsg = [];
    this.customServerErrorMsg = undefined;
  }

  sessionContinue() {
    this.updateSessionContinue();
  }

  updateSessionContinue() {
    this.emitterService.broadcastGetSessionLimitFlag();
    this.utils.closeMultiModal("sessionExpiredModal");
    Promise.resolve(this.sessionLimitService.getSessionLimit())
      .then(responsibleGamingData => {
        if (responsibleGamingData) {
          let realityDetails = responsibleGamingData;
          this.realityCheckService.updateSessionVariable(realityDetails["limits"]
            && realityDetails["limits"].overall.value ? realityDetails["limits"].overall.value : 0);
        }
      });
  }


  moveToTransaction() {
    this.updateSessionContinue();
    this.closeDepositModal();
    this.router.navigate([this.langCode + '/myaccount/transactions']);
  }

  moveToRealityCheck() {
    this.updateSessionContinue();
    this.closeDepositModal();
    this.router.navigate([this.langCode + '/myaccount'], { queryParams: { page: 'realitycheck' } });
  }

  logout() {
    this.closeDepositModal();
    this.realityCheckService.doLogout();
  }

  // Close deposit Modal
  closeDepositModal() {
    $("body").removeClass("modal-open");
    this.utils.closeMultiModal("sessionExpiredModal");
    this.utils.closeModal("hosted_cashier_modal");
    this.utils.closeModal("deposit_modal_country");
    this.emitterService.broadcastModalState({name:"paymentModal",state:"open", cashierType: "deposit" });
  }

  closeModal(modalId) {
    // this.sessionContinue();
    this.utils.closeModal(modalId);
  }

  close() {
    $("#depositLoadingModal").hide();
  }
  routeToLimits() {
    if (this.utils.isUserLoggedIn()) {
      this.router.navigate([this.langCode + '/setlimits']);
    } else {
      this.router.navigate([this.langCode + '/login'], { queryParams: { toSetLimit: 'setlimits' } });
    }
  }
  updateloader() {
    this.loading = false;
    this.router.navigate([this.langCode]);
  }

  openLandingPage(countries) {
    Promise.resolve(this.ajaxService.getLoginStatus()).then(data => {
      if (data && data["status"] === false && window.location.pathname === '/' + this.langCode) {
        if (environment.hasLandingpage && environment.landingpageCountries.length > 0
          && environment.landingpageCountries.indexOf(countries["country"]) !== -1) {
          this.landingPage = true;
          this.emitterService.broadcastLandingpage(true);
        } else {
          this.landingPage = false;
          this.emitterService.broadcastLandingpage(false);
        }
      }
    });
  }

  getRouteChild(activatedRoute: ActivatedRoute) {
    if (activatedRoute.firstChild) {
      return this.getRouteChild(activatedRoute.firstChild);
    } else {
      return activatedRoute;
    }
  }

  createCanonicalURL() {
    if($('link[rel="canonical"]').length === 0) {
      var canonicalLink = $("<link>");
          canonicalLink.attr("rel", "canonical");
          canonicalLink.attr("href", location.href);
          $('head').append(canonicalLink);
    }
    $('link[rel="canonical"]').attr('href', location.href);
  }

  getMetaDataForByRoute(activeRoute) {
    let routePath = this.getRouteChild(activeRoute);
    routePath.data.subscribe(data => {
      if(data && !(_.isEmpty(data)) && data?.title){
        data = {title:this.translate.instant(data.title), keywords:this.translate.instant(data.keywords), description:this.translate.instant(data.description)};
      }
      this.setMetaDataForSite(data);
    });
  }

  setMetaOGData() {
    let getOGobj = {
      url: this.translate.instant('seo.OGUrl'),
      type: this.translate.instant('seo.OGType'),
      title: this.translate.instant('seo.OGTitle'),
      image: this.translate.instant('seo.OGImage')
    };

    let ogUrl = window.location.href;
    if(((getOGobj.url).trim() !== '') && !getOGobj.url.includes('seo.')) {
      this.metaService.updateTag({ property: 'og:url', content: ogUrl });
    }
    if(((getOGobj.type).trim() !== '') && !getOGobj.type.includes('seo.')) {
      this.metaService.updateTag({ property: 'og:type', content: getOGobj.type });
    }
    if(((getOGobj.title).trim() !== '') && !getOGobj.title.includes('seo.')) {
      this.metaService.updateTag({ property: 'og:title', content: getOGobj.title });
    }
    if(((getOGobj.image).trim() !== '') && !getOGobj.image.includes('seo.')) {
      this.metaService.updateTag({ property: 'og:image', content: getOGobj.image });
    }
  }

  setMetaDataForSite(metaInfo) {
    this.setMetaOGData();
    this.createCanonicalURL();
    if (metaInfo && metaInfo.title && ((metaInfo.title).trim() !== "") && !metaInfo.title.includes('seo.')) {
      this.titleService.setTitle(metaInfo.title);
      this.metaService.updateTag({ name: 'title', content: metaInfo.title });
      this.metaService.updateTag({ property: 'og:title', content: metaInfo.title });
    } else {
      this.titleService.setTitle(this.translate.instant('seo.defaultPageMetaTitle'));
      this.metaService.updateTag({ name: 'title', content: this.translate.instant('seo.defaultPageMetaTitle') });
      this.metaService.updateTag({ property: 'og:title', content: this.translate.instant('seo.defaultPageMetaTitle') });
    }

    if (metaInfo && metaInfo.keywords && ((metaInfo.keywords).trim() !== "") && !metaInfo.keywords.includes('seo.')) {
      this.metaService.updateTag({ name: 'keywords', content: metaInfo.keywords });
    } else {
      this.metaService.updateTag({ name: 'keywords', content: this.translate.instant('seo.defaultPageMetaKeyWords') });
    }

    if (metaInfo && metaInfo.description && ((metaInfo.description).trim() !== "") && !metaInfo.description.includes('seo.')) {
      this.metaService.updateTag({ name: 'description', content: metaInfo.description });
    } else {
      this.metaService.updateTag({ name: 'description', content: this.translate.instant('seo.defaultPageMetaDescription')});
    }
    if (this.window.location.pathname.includes('/gameplay/')) {
      this.metaService.addTag({name: 'robots', content: 'noindex'});
    }else {
      let currentUrl = location.href;
      let domainNameInUrl = currentUrl.replace(/.+\/\/|www.|\..+/g, '');
      if((domainNameInUrl == environment.website_name && environment.restrictNoIndexLanguages[this.langCode] )|| (domainNameInUrl != environment.website_name && !environment.restrictNoIndexLanguages[this.langCode])){
        this.metaService.addTag({name: 'robots', content: 'noindex'});
      }else{
        this.metaService.removeTag("name='robots'");
      }
     
    }
  }



  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
